export default "__VITE_ASSET__qmdiWmyG__"